import { render, staticRenderFns } from "./DialogVulnerabilities.vue?vue&type=template&id=1819ab82"
import script from "./DialogVulnerabilities.vue?vue&type=script&lang=js"
export * from "./DialogVulnerabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports